import { NgModule } from '@angular/core';
import { SignupRoutingModule } from './signup.routing';
import { SignupComponent } from './signup.component';
import { LayoutComponent } from './layout/layout.component';
import { TranslateModule } from '@ngx-translate/core';
import { CompleteComponent } from './complete/complete.component';
import { FormsModule } from '@angular/forms';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { RegistrationService } from './shared/services/registration.service';
import { RegisterComponent } from './register/register.component';
import { ExpiredComponent } from './link_expired/expired.component';
import { PlatformComponent } from './platform/platform.component';
import { ProductComponent } from './product/product.component';
import { RegisterEffectsService } from './register/state/register_effects.service';
import { ApiHttpService } from '../shared/services/api_http.service';
import { B2bHttpService } from '../shared/services/b2b_http.service';
import { AppSharedModule } from '../shared/app_shared.module';
import { CompleteEffectsService } from './complete/state/complete_effects.service';
import { PlatformEffectsService } from './platform/state/platform_effects.service';
import { ProductEffectsService } from './product/state/product_effects.service';
import { SelectModule } from 'ng-select';
import { FinishComponent } from './finish/finish.component';
import { FinishEffectsService } from './finish/state/finish_effects.service';
import { RecaptchaModule } from 'ng-recaptcha';
import { ActivateComponent } from './activate/activate.component';
import { ReactiveFormsModule } from '@angular/forms';
import { Angulartics2Module } from 'angulartics2';
import { Angulartics2Facebook } from 'angulartics2/facebook';
import { ResetPasswordComponent } from './reset_password/reset_password.component';
import { PasswordsFormComponent } from './shared/change_password/passwords_form.component';
import { FlowTrackingService } from './shared/services/flow-tracking.service';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';
import { RedCrossAnalyticsTrackingService } from '@yotpo-ui/common-browser';

@NgModule({
  imports: [
    SignupRoutingModule,
    TranslateModule,
    FormsModule,
    BrowserModule,
    RouterModule,
    PopoverModule,
    AppSharedModule,
    SelectModule,
    RecaptchaModule,
    ReactiveFormsModule,
    Angulartics2Module.forRoot([Angulartics2Facebook]),
  ],
  declarations: [
    SignupComponent,
    LayoutComponent,
    CompleteComponent,
    RegisterComponent,
    PlatformComponent,
    ProductComponent,
    FinishComponent,
    ActivateComponent,
    ResetPasswordComponent,
    PasswordsFormComponent,
    ExpiredComponent
  ],
  providers: [
    RegisterEffectsService,
    ApiHttpService,
    B2bHttpService,
    RegistrationService,
    CompleteEffectsService,
    PlatformEffectsService,
    ProductEffectsService,
    FinishEffectsService,
    FlowTrackingService,
    {
      provide: AnalyticsTrackingProvider,
      useClass: RedCrossAnalyticsTrackingService
    }
  ],
  bootstrap: [SignupComponent]
})
export class SignupModule {}
